SNI.Application.addModule('asset-label', (context) => {

  return {
    behaviors: ['popover']
  };

});
